import axios from 'axios'

export const apiClient = axios
  .create({
    baseURL: process.env.VUE_APP_API_URL || '/', // fall back to same-origin so relative `api/...` calls resolve to /api/... on any route (prod has no dev proxy)
    withCredentials: true,
    headers: {
      Accept: 'application/json',
    },
  })